import * as Sentry from '@sentry/react';
import { initAnalytics } from './instrument';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
// Fonts must be imported before CSS
import './styles/fonts.css';
import './index.css';
import './styles/tokens.css';
import './modules/shared/styles/tokens.css'
import './styles/circles-newspaper.css'

import { BrowserRouter } from 'react-router-dom';

import { syncThemeColorMeta, DEFAULT_THEME_ID } from './modules/shared/styles/themePresets'

try {
  const savedTheme = typeof window !== 'undefined' ? window.localStorage.getItem('app_theme') : null
  const isDark = savedTheme ? savedTheme === 'dark' : false
  if (typeof document !== 'undefined') {
    document.documentElement.classList.toggle('dark', isDark)
  }
  // Sync theme-color meta with saved color preset
  const savedPreset = typeof window !== 'undefined' ? window.localStorage.getItem('y-theme-preset') : null
  syncThemeColorMeta(savedPreset ?? DEFAULT_THEME_ID)
} catch {}

// Initialize analytics after consent check (deferred, not at import time)
initAnalytics();

createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
